import { render, staticRenderFns } from "./SinAforo.vue?vue&type=template&id=c0e7a7ba"
import script from "./SinAforo.vue?vue&type=script&lang=js"
export * from "./SinAforo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports